(function () {
  'use strict';

  function particleWord(o) {
    var stage, canvas, textLayer, ctx, W = 0, H = 0, P = [], wanderers = [],
      mouse = { x: -9999, y: -9999 }, run = false, loop2 = false, bnd = false;

    function build() {
      stage = document.getElementById(o.stageId);
      canvas = document.getElementById(o.canvasId);
      textLayer = o.textId ? document.getElementById(o.textId) : null;
      if (!stage || !canvas) return false;
      ctx = canvas.getContext('2d');
      var r = stage.getBoundingClientRect();
      var stageW = Math.round(r.width), stageLeft = Math.round(r.left);
      H = Math.round(r.height);
      if (stageW < 10 || H < 8) return false;
      if (o.overflow !== false) {
        W = window.innerWidth;
        canvas.style.position = 'fixed';
        canvas.style.top = Math.round(r.top) + 'px';
        canvas.style.left = '0';
        canvas.style.right = 'auto';
        canvas.style.bottom = 'auto';
        canvas.style.width = W + 'px';
        canvas.style.height = H + 'px';
        canvas.style.pointerEvents = 'none';
        canvas.style.zIndex = '2';
      } else {
        W = stageW;
        stageLeft = 0;
      }
      canvas.width = W; canvas.height = H;
      var off = document.createElement('canvas');
      off.width = W; off.height = H;
      var oc = off.getContext('2d');
      var fs = Math.floor(H * (o.fontFactor || 0.72));
      oc.font = '800 ' + fs + 'px "Helvetica Neue",Helvetica,Arial,sans-serif';
      oc.textAlign = 'center'; oc.textBaseline = 'middle';
      oc.fillStyle = o.color;
      var word = o.word, sp = stageW * (o.spacing || 0.16);
      var tw = sp * (word.length - 1), sx = stageLeft + stageW / 2 - tw / 2;
      for (var c = 0; c < word.length; c++) oc.fillText(word[c], sx + c * sp, H / 2);
      var data;
      try { data = oc.getImageData(0, 0, W, H).data; } catch (e) { return false; }
      P = [];
      var gap = o.gap || 2;
      var scatterX = Math.min(stageW * 0.4, 240);
      for (var y = 0; y < H; y += gap) {
        for (var x = 0; x < W; x += gap) {
          var idx = (y * W + x) * 4;
          if (data[idx + 3] > 120) {
            var cr = Math.random();
            var pc = cr < 0.05 ? '#FFD700' : cr < 0.10 ? '#9B5FE3' : cr < 0.15 ? '#00CC66' : cr < 0.20 ? '#E63946' : o.color;
            P.push({
              ox: x, oy: y,
              x: x + (Math.random() - 0.5) * scatterX,
              y: y + (Math.random() - 0.5) * H * 3,
              vx: 0, vy: 0,
              size: 1.4 + Math.random() * 0.6,
              ph: Math.random() * Math.PI * 2,
              color: pc
            });
          }
        }
      }
      var nw = o.wanderers || 0;
      wanderers = [];
      if (nw > 0) {
        var wcx = stageLeft + stageW / 2, wcy = H / 2;
        for (var w = 0; w < nw; w++) {
          var wr = Math.random();
          var wc = wr < 0.05 ? '#FFD700' : wr < 0.10 ? '#9B5FE3' : wr < 0.15 ? '#00CC66' : wr < 0.20 ? '#E63946' : o.color;
          wanderers.push({ x: wcx + (Math.random()-0.5)*stageW*0.6, y: wcy + (Math.random()-0.5)*H*0.5, vx: (Math.random()-0.5)*1.5, vy: (Math.random()-0.5)*1.5, ph: Math.random()*Math.PI*2, size: 1.0+Math.random()*0.8, color: wc, cx: wcx, cy: wcy });
        }
      }
      return P.length > 6;
    }

    function lp() {
      ctx.clearRect(0, 0, W, H);
      var rad = o.radius || 60, frc = o.force || 22, ret = o.ret || 0.08, fr = o.friction || 0.90;
      var t = Date.now() * 0.001;
      for (var i = 0; i < P.length; i++) {
        var p = P[i];
        var dx = p.x - mouse.x, dy = p.y - mouse.y;
        var d = Math.sqrt(dx * dx + dy * dy);
        if (d < rad && d > 0.5) {
          var f = (rad - d) / rad;
          p.vx += (dx / d) * f * frc;
          p.vy += (dy / d) * f * frc;
        }
        p.vx += Math.sin(t * 1.1 + p.ph) * 0.22;
        p.vy += Math.cos(t * 0.8 + p.ph * 1.3) * 0.22;
        p.vx += (p.ox - p.x) * ret;
        p.vy += (p.oy - p.y) * ret;
        p.vx *= fr; p.vy *= fr;
        p.x += p.vx; p.y += p.vy;
        ctx.fillStyle = p.color || o.color;
        ctx.fillRect(p.x, p.y, p.size, p.size);
      }
      ctx.globalAlpha = 0.32;
      for (var j = 0; j < wanderers.length; j++) {
        var wp = wanderers[j];
        wp.vx += Math.sin(t * 0.6 + wp.ph) * 0.20;
        wp.vy += Math.cos(t * 0.4 + wp.ph * 1.4) * 0.20;
        wp.vx += (wp.cx - wp.x) * 0.004; wp.vy += (wp.cy - wp.y) * 0.004;
        wp.vx *= 0.94; wp.vy *= 0.94;
        wp.x += wp.vx; wp.y += wp.vy;
        ctx.fillStyle = wp.color;
        ctx.fillRect(wp.x, wp.y, wp.size, wp.size);
      }
      ctx.globalAlpha = 1;
      if (loop2) requestAnimationFrame(lp);
    }

    function bind() {
      if (bnd || !stage) return;
      bnd = true;
      stage.addEventListener('mousemove', function (e) {
        var r = canvas.getBoundingClientRect();
        mouse.x = e.clientX - r.left; mouse.y = e.clientY - r.top;
      });
      stage.addEventListener('mouseleave', function () { mouse.x = -9999; mouse.y = -9999; });
      if (o.onClick) stage.addEventListener('click', o.onClick);
      stage.addEventListener('touchmove', function (e) {
        e.preventDefault();
        var r = canvas.getBoundingClientRect(), t = e.touches[0];
        mouse.x = t.clientX - r.left; mouse.y = t.clientY - r.top;
      }, { passive: false });
      stage.addEventListener('touchend', function () { mouse.x = -9999; mouse.y = -9999; });
    }

    return {
      start: function () {
        if (run) { if (!loop2) { loop2 = true; lp(); } return; }
        if (build()) {
          run = true; loop2 = true; bind();
          if (textLayer) textLayer.style.opacity = '0';
          lp();
        } else {
          var self = this; setTimeout(function () { self.start(); }, 150);
        }
      },
      rebuild: function () {
        loop2 = false; run = false; P = []; wanderers = [];
        var self = this; setTimeout(function () { self.start(); }, 50);
      }
    };
  }

  /* ── Hero RED SKETCH ── */
  var heroFx = (function () {
    var stage, canvas, textLayer, ctx, W = 0, H = 0, P = [], wanderers = [],
      mouse = { x: -9999, y: -9999 }, run = false, loop2 = false, bnd = false;

    function build() {
      stage = document.getElementById('rv-hstage');
      canvas = document.getElementById('rv-hcanvas');
      textLayer = document.getElementById('rv-htext');
      if (!stage || !canvas) return false;
      ctx = canvas.getContext('2d');
      var r = stage.getBoundingClientRect();
      var stageW = Math.round(r.width), stageLeft = Math.round(r.left);
      H = Math.round(r.height);
      if (stageW < 20 || H < 20) return false;
      W = window.innerWidth;
      canvas.style.position = 'fixed';
      canvas.style.top = Math.round(r.top) + 'px';
      canvas.style.left = '0';
      canvas.style.right = 'auto';
      canvas.style.bottom = 'auto';
      canvas.style.width = W + 'px';
      canvas.style.height = H + 'px';
      canvas.style.pointerEvents = 'none';
      canvas.style.zIndex = '2';
      canvas.width = W; canvas.height = H;
      var off = document.createElement('canvas');
      off.width = W; off.height = H;
      var oc = off.getContext('2d');
      var lines = ['RED', 'SKETCH'], lhf = 0.82;
      var fs = Math.floor(H / (lines.length * lhf) * 0.99);
      oc.font = '800 ' + fs + 'px "Helvetica Neue",Helvetica,Arial,sans-serif';
      var w = oc.measureText('SKETCH').width, mw = stageW * 0.99;
      if (w > mw) { fs = Math.floor(fs * mw / w); oc.font = '800 ' + fs + 'px "Helvetica Neue",Helvetica,Arial,sans-serif'; }
      var lh = fs * lhf, th = lh * lines.length, sy = Math.max(0, (H - th) / 2);
      oc.textAlign = 'left'; oc.textBaseline = 'top';
      lines.forEach(function (l, li) {
        oc.fillStyle = li === 1 ? '#E63946' : '#0a0a0a';
        oc.fillText(l, stageLeft, sy + li * lh);
      });
      var data;
      try { data = oc.getImageData(0, 0, W, H).data; } catch (e) { return false; }
      P = [];
      for (var y = 0; y < H; y += 3) {
        for (var x = 0; x < W; x += 3) {
          var idx = (y * W + x) * 4;
          if (data[idx + 3] > 128) {
            P.push({
              ox: x, oy: y,
              x: x + (Math.random() - 0.5) * stageW * 0.8,
              y: y + (Math.random() - 0.5) * H * 0.8,
              vx: 0, vy: 0,
              red: data[idx] > 150 && data[idx + 1] < 120,
              size: 1.7 + Math.random() * 0.7,
              ph: Math.random() * Math.PI * 2
            });
          }
        }
      }
      wanderers = [];
      var hcx = stageLeft + stageW / 2, hcy = H / 2;
      for (var w = 0; w < 20; w++) {
        var wc = Math.random() < 0.3 ? '#E63946' : '#0a0a0a';
        wanderers.push({ x: hcx + (Math.random()-0.5)*stageW*0.8, y: hcy + (Math.random()-0.5)*H*0.7, vx: (Math.random()-0.5)*1.5, vy: (Math.random()-0.5)*1.5, ph: Math.random()*Math.PI*2, size: 1.2+Math.random()*0.8, color: wc, cx: hcx, cy: hcy });
      }
      return P.length > 20;
    }

    function lp() {
      ctx.clearRect(0, 0, W, H);
      var t = Date.now() * 0.001;
      for (var i = 0; i < P.length; i++) {
        var p = P[i];
        var dx = p.x - mouse.x, dy = p.y - mouse.y;
        var d = Math.sqrt(dx * dx + dy * dy);
        if (d < 78 && d > 0.5) {
          var f = (78 - d) / 78;
          p.vx += (dx / d) * f * 28;
          p.vy += (dy / d) * f * 28;
        }
        p.vx += Math.sin(t * 1.1 + p.ph) * 0.22;
        p.vy += Math.cos(t * 0.8 + p.ph * 1.3) * 0.22;
        p.vx += (p.ox - p.x) * 0.07; p.vy += (p.oy - p.y) * 0.07;
        p.vx *= 0.90; p.vy *= 0.90;
        p.x += p.vx; p.y += p.vy;
        ctx.fillStyle = p.red ? '#E63946' : '#0a0a0a';
        ctx.fillRect(p.x, p.y, p.size, p.size);
      }
      ctx.globalAlpha = 0.32;
      for (var j = 0; j < wanderers.length; j++) {
        var wp = wanderers[j];
        wp.vx += Math.sin(t * 0.6 + wp.ph) * 0.20;
        wp.vy += Math.cos(t * 0.4 + wp.ph * 1.4) * 0.20;
        wp.vx += (wp.cx - wp.x) * 0.004; wp.vy += (wp.cy - wp.y) * 0.004;
        wp.vx *= 0.94; wp.vy *= 0.94;
        wp.x += wp.vx; wp.y += wp.vy;
        ctx.fillStyle = wp.color;
        ctx.fillRect(wp.x, wp.y, wp.size, wp.size);
      }
      ctx.globalAlpha = 1;
      if (loop2) requestAnimationFrame(lp);
    }

    function bind() {
      if (bnd || !stage) return;
      bnd = true;
      stage.addEventListener('mousemove', function (e) {
        var r = canvas.getBoundingClientRect();
        mouse.x = e.clientX - r.left; mouse.y = e.clientY - r.top;
      });
      stage.addEventListener('mouseleave', function () { mouse.x = -9999; mouse.y = -9999; });
      stage.addEventListener('touchmove', function (e) {
        var r = canvas.getBoundingClientRect(), t = e.touches[0];
        mouse.x = t.clientX - r.left; mouse.y = t.clientY - r.top;
      }, { passive: false });
      stage.addEventListener('touchend', function () { mouse.x = -9999; mouse.y = -9999; });
    }

    return {
      start: function () {
        if (run) { if (!loop2) { loop2 = true; lp(); } return; }
        if (build()) {
          run = true; loop2 = true; bind();
          if (textLayer) textLayer.style.opacity = '0';
          lp();
        } else {
          var self = this; setTimeout(function () { self.start(); }, 150);
        }
      },
      rebuild: function () {
        loop2 = false; run = false; P = []; wanderers = [];
        var self = this; setTimeout(function () { self.start(); }, 50);
      }
    };
  })();

  /* ── Tunnel ── */
  var tunnelFx = (function () {
    var canvas, ctx, W = 0, H = 0, run = false, loop2 = false, t0 = 0;
    var words = ['RED SKETCH', 'DROP 001', '55 UNITS', '10 FABRICS', 'ZULA CEBİ', 'BAGGY JORTS'];

    function build() {
      var wrap = document.getElementById('rv-tunnel');
      canvas = document.getElementById('rv-tunnel-canvas');
      if (!wrap || !canvas) return false;
      if (wrap.dataset.words) {
        var custom = wrap.dataset.words.split(',').map(function (w) { return w.trim(); }).filter(Boolean);
        if (custom.length) words = custom;
      }
      ctx = canvas.getContext('2d');
      var r = wrap.getBoundingClientRect();
      W = Math.round(r.width); H = Math.round(r.height);
      if (W < 20 || H < 10) return false;
      canvas.width = W; canvas.height = H;
      t0 = Date.now();
      return true;
    }

    function lp() {
      ctx.clearRect(0, 0, W, H);
      var t = (Date.now() - t0) / 1000;
      var spacing = W / 2.6, speed = 130, total = words.length * spacing;
      ctx.textBaseline = 'middle';
      for (var i = 0; i < words.length * 2; i++) {
        var word = words[i % words.length];
        var x = ((i * spacing) - (t * speed)) % total;
        if (x < 0) x += total;
        var prog = x / total;
        var scale = 0.62 + prog * 0.85;
        var alpha = 0.3 + prog * 0.7;
        var fs = Math.min(H * 0.74, Math.max(8, (H * 0.5) * scale));
        ctx.font = '800 ' + fs + 'px "Helvetica Neue",Helvetica,Arial,sans-serif';
        ctx.fillStyle = 'rgba(10,10,10,' + alpha.toFixed(2) + ')';
        ctx.fillText(word, x, H / 2);
      }
      if (loop2) requestAnimationFrame(lp);
    }

    return {
      start: function () {
        if (run) { if (!loop2) { loop2 = true; lp(); } return; }
        if (build()) {
          run = true; loop2 = true; lp();
        } else {
          var self = this; setTimeout(function () { self.start(); }, 150);
        }
      },
      rebuild: function () {
        loop2 = false; run = false;
        var self = this; setTimeout(function () { self.start(); }, 50);
      }
    };
  })();

  /* ── CULTURE door ── */
  var cultureDoor = particleWord({
    stageId: 'rv-culture-door', canvasId: 'rv-cd-canvas', textId: 'rv-cd-text',
    word: 'CULTURE', color: '#0a0a0a',
    gap: 2, radius: 70, force: 26, ret: 0.08, friction: 0.90, wanderers: 25,
    onClick: function () { window.location.href = '/pages/culture'; }
  });

  /* ── Nav CULTURE (header) ── */
  var navStage = document.getElementById('rv-nav-culture-stage');
  var navCulture = (navStage && !navStage.classList.contains('rv-nav-hidden')) ? particleWord({
    stageId: 'rv-nav-culture-stage', canvasId: 'rv-nav-culture-canvas', textId: 'rv-nav-culture-text',
    word: 'CULTURE', color: navStage.dataset.color || '#0a0a0a',
    gap: 1, fontFactor: 0.65, spacing: 0.135,
    radius: 35, force: 14, ret: 0.10, friction: 0.88, wanderers: 15,
    overflow: false
  }) : null;

  /* ── Init ── */
  function init() {
    if (document.getElementById('rv-hstage')) heroFx.start();
    if (document.getElementById('rv-culture-door')) cultureDoor.start();
    if (document.getElementById('rv-tunnel')) tunnelFx.start();
    if (navCulture) navCulture.start();
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { setTimeout(init, 60); });
  }
  setTimeout(init, 450);

  var _rvResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(_rvResizeTimer);
    _rvResizeTimer = setTimeout(function () {
      if (document.getElementById('rv-hstage')) heroFx.rebuild();
      if (document.getElementById('rv-culture-door')) cultureDoor.rebuild();
      if (document.getElementById('rv-tunnel')) tunnelFx.rebuild();
      if (navCulture) navCulture.rebuild();
    }, 200);
  });
})();
